import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-27d956aa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "about"
}
const _hoisted_2 = {
  key: 1,
  class: "about"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Bitte melde dich mit deinem Account an, um auf Clubshop zuzugreifen.", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!

  return (_ctx.userLoggedIn.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", null, "Willkommen zurück " + _toDisplayString(_ctx.user.value.name) + "!", 1)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(_component_el_button, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.login()))
        }, {
          default: _withCtx(() => [
            _createTextVNode("Login")
          ]),
          _: 1
        })
      ]))
}